import LoopSlider from "./LoopSlider";
import Swiper from "swiper";
import {
	Pagination,
	Autoplay,
	Navigation,
	EffectFade,
	Thumbs,
	Scrollbar,
} from "swiper/modules";

$(document).ready(() => {
	const homeBannerSlider = new Swiper(".home-banner-slider .swiper", {
		modules: [Autoplay, Pagination, EffectFade],
		slidesPerView: 1,
		loop: true,
		effect: "fade",
		speed: 2000,
		autoplay: {
			delay: 4000,
			disableOnInteraction: false,
		},
		pagination: {
			el: ".home-banner-slider .swiper-pagination",
			clickable: true,
		},
	});

	const singleNewsSlider = new Swiper(".single-news-slider .swiper", {
		modules: [Navigation, EffectFade],
		slidesPerView: 1,
		loop: true,
		effect: "fade",
		speed: 2000,
		navigation: {
			nextEl: ".single-news-slider .swiper-btn-next",
			prevEl: ".single-news-slider .swiper-btn-prev",
		},
	});

	const serviceDetailSlider = new Swiper(".service-detail-slider .swiper", {
		modules: [Navigation],
		slidesPerView: 1,
		loop: true,
		speed: 2000,
		navigation: {
			nextEl: ".service-detail-slider .swiper-btn-next",
			prevEl: ".service-detail-slider .swiper-btn-prev",
		},
		spaceBetween: 20,
	});

	const singleSlider = new LoopSlider(
		".single-slider",
		{
			1024: {
				spaceBetween: 40,
				slidesPerView: 1,
				centeredSlides: false,
			},
		},
		{
			centeredSlides: true,
		}
	);

	const doubleSlider = new LoopSlider(
		".double-slider",
		{
			576: {
				spaceBetween: 20,
				slidesPerView: 1.5,
			},
			1024: {
				spaceBetween: 40,
				slidesPerView: 2,
				centeredSlides: false,
			},
		},
		{
			centeredSlides: true,
		}
	);

	const tripleSlider = new LoopSlider(".triple-slider", {
		576: {
			spaceBetween: 20,
			slidesPerView: 2.5,
		},
		1024: {
			spaceBetween: 40,
			slidesPerView: 3,
			centeredSlides: false,
		},
	});

	const quadrupleSlider = new LoopSlider(".quadruple-slider", {
		576: {
			spaceBetween: 20,
			slidesPerView: 2.5,
		},
		768: {
			spaceBetween: 20,
			slidesPerView: 3.5,
		},
		1024: {
			spaceBetween: 40,
			slidesPerView: 4,
			centeredSlides: false,
		},
	});
});
